<template>
  <OrganismModal
    v-model:is-shown="isModalOpen"
    data-cy="storage-capacity-modifiable-modal"
    :title="
      t('subscription.solarProductionStorage.batteryStorage.mySmartBattery.modifiableModal.title')
    "
    has-separator
    size="lg"
    @cancel="handleClose"
  >
    <AtomText
      :text="
        t('subscription.solarProductionStorage.batteryStorage.mySmartBattery.modifiableModal.intro')
      "
      font-size="text-sm"
    />
    <AtomText is-tag="ul" class="list-disc pl-6" font-size="text-sm">
      <AtomText is-tag="li">
        <AtomText
          is-tag="span"
          font-style="font-semibold"
          font-size="text-sm"
          :text="
            t(
              'subscription.solarProductionStorage.batteryStorage.mySmartBattery.modifiableModal.listItems.increase.term'
            )
          "
        />
        <AtomText
          is-tag="span"
          font-size="text-sm"
          :text="
            t(
              'subscription.solarProductionStorage.batteryStorage.mySmartBattery.modifiableModal.listItems.increase.description'
            )
          "
        />
      </AtomText>
      <AtomText is-tag="li">
        <AtomText
          is-tag="span"
          font-style="font-semibold"
          font-size="text-sm"
          :text="
            t(
              'subscription.solarProductionStorage.batteryStorage.mySmartBattery.modifiableModal.listItems.reduce.term'
            )
          "
        />
        <AtomText
          is-tag="span"
          font-size="text-sm"
          :text="
            t(
              'subscription.solarProductionStorage.batteryStorage.mySmartBattery.modifiableModal.listItems.reduce.description'
            )
          "
        />
      </AtomText>
    </AtomText>
    <AtomText
      :text="
        t('subscription.solarProductionStorage.batteryStorage.mySmartBattery.modifiableModal.outro')
      "
      font-size="text-sm"
      class="mb-6"
    />

    <AtomText
      :text="
        t(
          'subscription.solarProductionStorage.batteryStorage.mySmartBattery.modifiableModal.limitedReduction.title'
        )
      "
      font-style="font-semibold"
      font-size="text-base"
      class="mb-1"
    />
    <AtomText
      :text="
        t(
          'subscription.solarProductionStorage.batteryStorage.mySmartBattery.modifiableModal.limitedReduction.description'
        )
      "
      font-size="text-sm"
      class="mb-6"
    />

    <AtomText
      :text="
        t(
          'subscription.solarProductionStorage.batteryStorage.mySmartBattery.modifiableModal.startWith100.title'
        )
      "
      font-style="font-semibold"
      font-size="text-base"
      class="mb-1"
    />
    <AtomText
      :text="
        t(
          'subscription.solarProductionStorage.batteryStorage.mySmartBattery.modifiableModal.startWith100.description'
        )
      "
      font-size="text-sm"
    />

    <template #footer="{ cancel }">
      <div class="flex justify-end">
        <MoleculeButton
          data-cy="storage-capacity-modifiable-modal-close-button"
          variant="tertiary"
          :label="t('common.close')"
          @click="cancel"
        />
      </div>
    </template>
  </OrganismModal>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps<{
  isOpen: boolean;
}>();

const emit = defineEmits(['update:isOpen']);

const { t } = useI18n();

const isModalOpen = computed({
  get: () => props.isOpen,
  set: (newState: boolean) => {
    emit('update:isOpen', newState);
  },
});

const handleClose = () => (isModalOpen.value = false);
</script>
